<template>
  <section>
    <Banner value="Equipe" />

    <section style="background:#DDD;">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p class="lead">
              A Escola Engenho mantém um quadro de profissionais especializados
              e estimula a formação continuada de seus professores para
              assegurar um trabalho de qualidade. Com isto, a equipe está sempre
              atualizada em relação aos conteúdos específicos, aos procedimentos
              pedagógicos de ensino-aprendizagem e à sistemática de avaliação do
              desempenho dos alunos.
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <v-container grid-list-lg>
      <v-layout row wrap my-4>
        <v-flex sm4 v-for="(l1, i1) in levels" :key="i1">
          <Level1 :color="colors[i1]" :level1="l1" :icon="icons[i1]" />
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import Level1 from "../../components/equipe/Level1.vue";
import jsonData from "../../../public/api/v1/equipe/1.json";

export default {
  data: () => ({
    equipe: null,
    icons: ["fas fa-child fa-2x", "fas fa-atom fa-2x", "fas fa-user-tie fa-2x"],
    colors: ["blue", "orange lighten-1", "grey"],
    levels: null
  }),
  components: {
    Banner,
    Level1
  },
  created: function() {
    this.levels = jsonData.levels;
  }
};
</script>

<style lang="scss" scoped>
p {
  text-align: left !important;
  font-weight: bold;
}

.level2-title {
  font-weight: bold;
  color: rgba(255, 255, 255, 0.5);
  display: block;
  padding: 10px 0 5px 0px;
  margin: 0px 0 0 15px;
}

.people-name {
  color: white;
}
</style>
